import { __decorate, __metadata, __param } from "tslib";
import { Inject, Injectable } from 'angular-ts-decorators';
import { GroupRestrictedSpotType } from 'src/Shared/enums/group-restricted-spot-type.enum';
var DynamicPagesSpotsDisplayOptionsService = (function () {
    function DynamicPagesSpotsDisplayOptionsService($http, $q) {
        this.$http = $http;
        this.$q = $q;
    }
    DynamicPagesSpotsDisplayOptionsService.prototype.getDisplayOptions = function (supportPageUrl, spotType) {
        return this.$http
            .get("/support/api/dynamicPagesSpotsDisplayOptionsService/displayoptions?supportPageUrl=" + supportPageUrl + "&spotType=" + GroupRestrictedSpotType[spotType])
            .then(function (response) { return response.data; });
    };
    DynamicPagesSpotsDisplayOptionsService.prototype.getSpotUrlOrEmpty = function (supportPageUrl, groupRestrictedSpotType, localScope, groupId, spotsPageUrl) {
        var _a;
        if (!localScope.isUpdated && groupRestrictedSpotType !== GroupRestrictedSpotType.Other) {
            return this.getDisplayOptions(supportPageUrl, groupRestrictedSpotType)
                .then(function (displayOptions) {
                var _a;
                localScope.showForAllGroups = displayOptions.showForAllGroups;
                localScope.displaySpotForGroups = displayOptions.displaySpotForGroups;
                localScope.isUpdated = true;
                if (!(localScope.showForAllGroups || ((_a = localScope.displaySpotForGroups) === null || _a === void 0 ? void 0 : _a.indexOf(groupId)) > -1)) {
                    return '';
                }
                return spotsPageUrl;
            });
        }
        else if (!!localScope.isUpdated && !(localScope.showForAllGroups || ((_a = localScope.displaySpotForGroups) === null || _a === void 0 ? void 0 : _a.indexOf(groupId)) > -1)) {
            return this.$q.when('');
        }
        return this.$q.when(spotsPageUrl);
    };
    DynamicPagesSpotsDisplayOptionsService.$inject = ['$http'];
    DynamicPagesSpotsDisplayOptionsService = __decorate([
        Injectable('dynamicPagesSpotsDisplayOptionsService'),
        __param(0, Inject('$http')), __param(1, Inject('$q')),
        __metadata("design:paramtypes", [Function, Function])
    ], DynamicPagesSpotsDisplayOptionsService);
    return DynamicPagesSpotsDisplayOptionsService;
}());
export { DynamicPagesSpotsDisplayOptionsService };
